import React from "react";
import { WifiOff } from "lucide-react";
import { useOffline } from "../hooks/usePWA";

export function OfflineBanner() {
  const isOffline = useOffline();

  if (!isOffline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-2 py-2 px-4"
      style={{
        background: "#2B2623",
        borderBottom: "1px solid #C17F59",
        fontFamily: "'Lora', Georgia, serif",
      }}
      data-testid="offline-banner"
    >
      <WifiOff size={13} strokeWidth={1.5} className="text-[#C17F59] flex-shrink-0" />
      <span className="text-xs text-[#DCD4C6] italic">
        Mode hors connexion · Vos itinéraires sont disponibles · Chat IA indisponible
      </span>
    </div>
  );
}
